import React, { FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowMagazinesProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  useEffect(() => {
    const $slider = $('.js-recruitment-magazines')
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        prevArrow: '<div class="recruitment__show__company__slider--prev"></div>',
        nextArrow: '<div class="recruitment__show__company__slider--next"></div>',
        responsive: [
          {
            breakpoint: 929,
            settings: {
              arrows: false
            }
          }
        ]
      })
    }
  }, [props.mags])

  return (
    <Presentation
      {...props}
    />
  );
};
